<template>
    <div class="mPage">
        <div class="top">
            <img src="../img/m/m_logo.png" alt="" class="logo">
            <span class="title">{{ $t("message.guest") }}</span>
            <slot></slot>
        </div>
        <div class="content">
            <div class="avatarCon" v-if="$i18n.locale=='cn'" >
                <div  class="guestShowItem" v-if="guestList.length>0">
                   
                    <div class="info">
                         <div class="imgShowCon">
                            <img :src="'http://conference2019.hanban.org'+'/upload/'+guestList[currentGuestIndex].avatar" alt="" class="imgShow" v-on:load="loadImg('.imgShowCon',currentGuestIndex, $event)" :class="{ 'toWidth': guestList[currentGuestIndex]['toWidth'] == true}">
                        </div> 
                        <div class="realName">
                            {{guestList[currentGuestIndex].realname}}
                        </div>
                         <div class="proFile">
                            {{guestList[currentGuestIndex].title}}
                        </div>
                        <div class="proFileInfo">
                            <span v-if="guestList[currentGuestIndex].id == 378" class="item">
                            <span v-html="profileList[0].profile"></span>
                            <!-- <span v-html="profileList[0].profile"></span> -->
                            </span>
                            <span v-if="guestList[currentGuestIndex].id == 209">
                                <span v-html="profileList[1].profile"></span>
                            </span>
                            <span v-if="guestList[currentGuestIndex].id == 272">
                                <span v-html="profileList[2].profile"></span>
                            </span>
                            <span v-if="guestList[currentGuestIndex].id == 379">
                                <span v-html="profileList[3].profile"></span>
                            </span>
                            <span v-if="guestList[currentGuestIndex].id == 380">
                                <span v-html="profileList[4].profile"></span>
                            </span>
                        </div>
                        
                    </div>
                    
                </div>
                <div class="guestCon">
                    <div  class="container" v-for="(item, index) in guestList" :key="index" :class="{ 'currentImg': index == currentGuestIndex}">
                        <div class="imgCon"  @click="showCurrent(index)">
                            <img :src="'http://conference2019.hanban.org'+'/upload/'+item.avatar" alt="" class="itemImg" v-on:load="loadImg('.imgCon',index, $event)" :class="{ 'toWidth': item['toWidth'] == true}">
                        </div>   
                        
                    </div>
                </div>
            </div>
            <div class="avatarCon" v-if="$i18n.locale=='en'" >
                <div  class="guestShowItem" v-if="guestList.length>0">
                   
                    <div class="info enInfo">
                         <div class="imgShowCon">
                            <img :src="'http://conference2019.hanban.org'+'/upload/'+guestList[currentGuestIndex].avatar" alt="" class="imgShow" v-on:load="loadImg('.imgShowCon',currentGuestIndex, $event)" :class="{ 'toWidth': guestList[currentGuestIndex]['toWidth'] == true}">
                        </div> 
                        <div class="realName">
                            {{guestList[currentGuestIndex].realname_en}}
                        </div>
                         <div class="proFile">
                            {{guestList[currentGuestIndex].title_en}}
                        </div>
                        <div class="proFileInfo">
                            <span v-if="guestList[currentGuestIndex].id == 378">
                                <span v-html="profileList[0].profile_en"></span>
                            </span>
                            <span v-if="guestList[currentGuestIndex].id == 209">
                                <span v-html="profileList[1].profile_en"></span>
                            </span>
                            <span v-if="guestList[currentGuestIndex].id == 272">
                                <span v-html="profileList[2].profile_en"></span>
                            </span>
                            <span v-if="guestList[currentGuestIndex].id == 379">
                                <span v-html="profileList[3].profile_en"></span>
                            </span>
                            <span v-if="guestList[currentGuestIndex].id == 380">
                                <span v-html="profileList[4].profile_en"></span>
                            </span>
                            
                        </div>
                        
                    </div>
                    
                </div>
                <div class="guestCon">
                    <div  class="container" v-for="(item, index) in guestList" :key="index" :class="{ 'currentImg': index == currentGuestIndex}">
                        <div class="imgCon" @click="showCurrent(index)">
                            <img :src="'http://conference2019.hanban.org'+'/upload/'+item.avatar" alt="" class="itemImg" v-on:load="loadImg('.imgCon',index, $event)" :class="{ 'toWidth': item['toWidth'] == true}">
                        </div>   
                        
                    </div>
                </div>
            </div>
        </div>
        <img src="../img/m/arrow_down.png" alt="" class="arrowDown">
    </div>
</template>

<script>
export default {
    name: 'm_picture',
    components: {
        
    },
    data: function () {
        return {
        guestList: [],
        profileList: [{
            profile_en: 'Lance Tatum, M.A. in management and Ph.D in philosophy. He joined the Troy University as an assistant professor in 1988. He previously served as Director and Dean of the School of Hospitality, Sport and Tourism Management, Dean of College of Education, Vice Chancellor for the Montgomery Campus, and Vice Chancellor for Global Campus. On January 1, 2019, Dr. Tatum was appointed as the Senior Vice Chancellor for Academic Affairs of Troy University. He is responsible for the formulation and implementation of the academic priorities and for the allocation of the resources to support those priorities. Besides, he is also responsible for the formulation and implementation of academic plans and policies, and for supervision over the work of departments, schools and research centers. From 2000 to 2008, Dr. Tatum has served on a variety of statewide boards and commissions related to education, as well as served as Athletics Faculty Representative at the National Collegiate Athletic Association (NCAA). He currently serves on the Board of Trustees/ Directors of the Air University Foundation, the Greater Montgomery YMCA, the American Association of University Administrators and the Alabama-Korea Educational and Economic Partnership.',
            profile: '兰斯·塔特姆 （Lance Tatum）, 管理学硕士、哲学博士，1988年作为助理教授入职特洛伊大学， 曾任酒店、体育及旅游管理学院系主任、院长，教育学院院长、蒙哥马利校区副校长，全球校园副校长。2019年1月1日，被任命为特洛伊大学学术事务高级副校长。主要负责制订、执行大学优先学术项目，并为其配置资源支持；制定、执行学术计划和政策，并监督学院、院系、研究中心的工作。2000年到2008年期间，曾在多个与教育有关的州级委员会任职，并在全国大学生体育协会(NCAA)担任体育教师代表。目前兼任航空大学基金会董事会、大蒙哥马利基督教青年会董事会、美国大学管理协会董事会和阿拉巴马-韩国教育和经济伙伴关系董事会成员。',
            profile_1: ''
        },{
            profile_en: 'Liu Li, President of Beijing Language and Culture University (BLCU). He holds a doctorate in literature and is a professor and doctoral supervisor. He is mainly engaged in teaching and research of ancient Chinese, Chinese grammar, the history of Chinese grammar, and the history of Chinese vocabulary. He has published more than 50 papers in academic journals including <span class="book"> Studies of the Chinese Language, Research in Ancient Chinese Language, Journal of Beijing Normal University, Studies on the History of Chinese Language, and Journal of Chinese Language History. </span>He has also published works including <span class="book">Research on Pre-Qin Chinese Auxiliary Verbs.</span> He has won awards such as “Innovation Model of Beijing Science and Technology” and “Li Yun Award for Young Teacher” of Beijing Normal University.',
            profile: '刘利，北京语言大学校长。文学博士，教授，博士生导师。主要从事古代汉语、汉语语法学、汉语语法史、汉语词汇史的教学与研究。先后在《中国语文》《古汉语研究》《北京师范大学学报》《汉语史研究辑刊》《汉语史学报》等学术期刊发表论文50多篇。出版《先秦汉语助动词研究》等多部著作。曾获“北京市科技创新标兵”、北京师范大学“励耘优秀青年教师奖”等奖项。'
        }, {
            profile_en: 'Luminita Balan, Director, Professor, and Sinologist of Chinese Department of the University of Bucharest, and Member of European Association for Chinese Studies, is dedicated to studies of Chinese linguistics, Chinese philosophy, modern and contemporary Chinese culture, and translation. She translated the Chinese classics <span class="book">Zhuangzi, Xunzi,</span> and works of contemporary Chinese authors such as Mo Yan, and Liu Zhenyun. She holds a friendly attitude to China. She won the Confucius Institute Individual Performance Excellence Award in 2016 and the Special Book Award of China in 2018. In the same year, she was also named Light of Civilization 2018- Chinese Cultural Exchange Person of the Year. In 2019, she won the Chinese Government Friendship Award and the honorary medal of China University of Political Science and Law.',
            profile: '白罗米（Luminita Balan），布加勒斯特大学外国语学院中文系主任，教授，汉学家，欧洲汉学学会会员。主要从事汉语言学、中国哲学、现当代中国文化、翻译研究，曾翻译《庄子》《荀子》及莫言、刘震云等当代作家的作品。对华非常友好。2016年获得“孔子学院先进个人”。2018年获得“中华图书特殊贡献奖” “文明之光——2018中国文化交流年度人物”。2019年获得“中国政府友谊奖”称号、中国政法大学荣誉奖章。'
        },{
            profile_en: 'Andriamamonjy Ratsimiseta Oniniaina received a master degree in tourism management at University of Antananarivo, Madagascar and a master degree of Teaching Chinese to Speakers of Other Languages at Jiangxi Normal University, China. As a local teacher, she is currently an assistant to the Director of the Confucius Institute at University of Antananarivo, Madagascar, and in charge of external contacts and teaching management. She was awarded the "Chinese Ambassador Award" by the Chinese Embassy in Madagascar in 2014 and 2018, and won the excellent Chinese test scholarship of the Confucius Institute at University of Antananarivo in 2016. ',
            profile: '吴妮（Andriamamonjy Ratsimiseta Oniniaina）， 马达加斯加塔那那利佛大学旅游管理硕士、中国江西师范大学汉语国际教育硕士。现任马达加斯加塔那那利佛大学孔子学院院长助理、本土教师，负责孔子学院外联工作，并协助教学管理。 2014年、2018年获中国驻马达加斯加大使馆“汉语使者奖”，2016年获塔那那利佛大学孔子学院优秀汉语考试奖学金。'
        },{
            profile_en: 'Yutaka Furukawa, Director, Professor and Doctoral supervisor of Chinese Language Department of Osaka University. Vice President of the International Society for Chinese Language Teaching, Guest Professor of the Center for Studies of Chinese as a Second Language of Beijing Language and Culture University, and “Hai-Tian” (Sea-Sky) Scholar of Dalian University of Technology. He previously served as the editorial board member of many journals such as the <span class="book">Chinese Teaching in the World, Journal of Chinese Language Studies, and Journal of Chinese Teaching and Research.</span> He also served as President of the Japan Association of Chinese Language Education, Chairman of Asia-Pacific Consortium of Teaching Chinese as an International Language, Visiting Scholar of Nanyang Technological University of Singapore, Foreign Expert of School of Chinese Studies and Exchange of Shanghai International Studies University, and Lecturer of NHK Chinese Lectures.',
            profile: '古川裕 (Furukawa Yutaka), 日本大阪大学中国语专业主任、教授、博士生导师。世界汉语教学学会副会长、北京语言大学对外汉语研究中心客座教授、大连理工大学海天学者。担任《世界汉语教学》（世界汉语教学学会）、《汉语教学学刊》（北京大学）、《汉语与汉语教学研究》（樱美林大学）等多家期刊编委。曾任日本中国语教育学会会长、亚太地区国际汉语教学学会会长、新加坡南洋理工大学访问学者、上海外国语大学国际文化交流学院外国专家、日本NHK电视台中文讲座主讲人等。'
        }],
        currentGuestIndex: 0,
        }
    },
    computed: {
        language() {
            return this.$i18n.locale
        }
    },
    methods: {
    close () {
        this.isShowModal = false
    },
              // 根据图片宽高比动态显示不同样式
    loadImg (dom, i, e) {
        var wrapperWidth = $(dom).width()
        var wrapperHeight = $(dom).height()
        if(e.target.naturalWidth/e.target.naturalHeight - (wrapperWidth/wrapperHeight) > 0){
            this.$set(this.guestList[i], 'toWidth', false)
        $(e.target).css('transform','translateX(-'+(e.target.width-wrapperWidth)/2+'px)')
        }else {
            this.$set(this.guestList[i], 'toWidth', true)
            $(e.target).css('width', 'auto')
            var radio = wrapperWidth/e.target.naturalWidth
            $(e.target).css('transform','translateX(-'+(e.target.height*radio-wrapperHeight)/2+'px)')
        }
    },
    getAllList() {
      this.$utils
        .get("guest/api/getAllGuestsList", {
          lang: this.language,
          type: 1
        })
        .then(res => {
          this.guestList = res.data.data.list
        });
    },
    toDetail(item) {
        window.open(item.link)
    },
    showCurrent (index) {
        this.currentGuestIndex = index
        $('.proFileInfo').scrollTop(0)
    },

    },
    watch: {
        // 监听切换语言
      language (newval, old) {
          this.getAllList()
      }
    },
  mounted() {
      this.getAllList()
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.mPage {
    width: 100%;
    height: 100%;
    overflow: hidden;
    .top {
        height: 1.4rem;
        line-height: 1.4rem;
        position: relative;
        .logo {
            width: 1.27rem;
            margin: auto 0.34rem;
            vertical-align: middle;
        }
        .title {
            position: absolute;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            margin: auto;
            width: 1.93rem;
            display: inline-block;
            text-align: center;
            font-size: 0.46rem;
            white-space: nowrap;
            color: #f3bc65;

        }
        .menu {
            position: absolute;
            top: 0;
            bottom: 0;
            margin: auto;
            right: 0.34rem;
            width: 0.51rem;
            vertical-align: middle;
        }
    }
    .content {
        height: calc(100% - 1.4rem);
        line-height: calc(100% - 1.4rem);
        text-align: center;
        
        position: relative;
        .avatarCon {
            height: 100%;
            .guestShowItem {
                height: calc(100% - 2.18rem);
                .info {
                        .imgShowCon {
                            margin:0 auto 0.4rem;
                            width: 3.49rem;
                            height: 4.47rem;
                            z-index: 2;
                            overflow: hidden;
                            
                            img {
                                height: 100%;
                            }
                            .toWidth {
                                width: 100%;
                                height: auto;
                            }
                        }
                        
                        //overflow-y: auto;
                        
                        .realName {
                            font-size: 0.5rem;
                            color: #fff;
                            font-weight: bold;
                            line-height: 1;
                            text-align: center;
                            
                            box-sizing: border-box;
                            white-space: initial;
                            word-break: initial;
                        }
                        .proFileInfo,.proFile { 
                            font-size: 0.28rem;
                            color: #fff;
                            opacity: 0.8;
                            width: calc(100% - 0.8rem);
                            box-sizing: border-box;
                            padding-bottom: 0.1rem;
                            padding-right: 0.2rem;
                            margin: 0.1rem 0.1rem 0.1rem 0.4rem;
                            word-break: initial;
                            line-height: 1.2;
                            text-align: left;
                            max-height: 1.65rem;
                            overflow-y: auto;
                            /deep/ .book {
                                font-style: italic;
                            }
                        }
                        .proFile {
                            opacity: 1;
                        }
                        .proFileInfo {
                            overflow-y: auto;
                            font-size: 0.24rem;
                        }
                    }
                    .enInfo {
                        .realName {
                            font-size: 0.4rem;
                        }
                    }
            }
            .guestCon {
                .container {
                    display: inline-block;
                    width: 1.06rem;
                    height: 1.4rem;
                    overflow: hidden;
                    margin-right: 0.2rem;
                    border: 1px solid #fff;
                    box-sizing: border-box;
                    div {
                        width: 100%;
                        height: 100%;
                        
                    }
                    
                }
                .currentImg {
                    border: 2px solid #f3bc65;
                    
                }
                img {
                    height: 100%;
                }
                .toWidth {
                    
                    width: auto;
                }
            }
        }

    }
    .arrowDown {
        position: absolute;
        bottom: 0.48rem;
        left: 0;
        right: 0;
        width: 0.28rem;
        margin: auto;
        animation: rotation 0.8s infinite alternate-reverse;
    }
    .secondPage {
        position: absolute;
        left: 0;
        width: 100%;
        height: 100%;
        overflow: hidden;
        background-image: url(../img/m/m_bg.png);
        background-size: cover;
    }
}
@-webkit-keyframes rotation {
    from {transform: translateY(0)}
    to   {transform: translateY(5px)}
}
</style>
